// Module
var code = "<ui-v2-embed id=\"bgworker\" src=\"/v2/embed/admin/bgworker\" data-ng-if=\"me.gteSpace()\"></ui-v2-embed> ";
// Exports
export default code;